<template>
  <div class='supplier-highWay' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='form' label-width='85px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='供应商:'>
          <el-input v-model='form.supplier' size='mini' placeholder='请输入供应商'></el-input>
        </el-form-item>
        <el-form-item label='委托商:'>
          <el-input v-model='form.consignorName' size='mini' placeholder='请输入委托商'></el-input>
        </el-form-item>
        <el-form-item label='批次号:'>
          <el-input v-model='form.batch' size='mini' placeholder='请输入批次号'></el-input>
        </el-form-item>
        <el-form-item label='运单编号:'>
          <el-input v-model='form.waybill' size='mini' placeholder='请输入运单编号'></el-input>
        </el-form-item>
        <el-form-item label='车架号:'>
          <el-input v-model='form.frame' size='mini' placeholder='请输入车架号'
                    @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'frame')}"
          ></el-input>
        </el-form-item>
        <el-form-item label='品牌:'>
          <el-input v-model='form.brand' size='mini' placeholder='请输入品牌名称'></el-input>
        </el-form-item>
        <el-form-item label='台账月:'>
          <el-input v-model='form.month' size='mini' placeholder='请输入台账月'></el-input>
        </el-form-item>
        <el-form-item label='补结算对账编号：' label-width="130px">
          <el-input v-model='form.actNoAdd' size='mini' placeholder='请输入补结算对账编号'  style="width: 160px"/>
        </el-form-item>
        <el-form-item label='补结算对账标题：' label-width="130px">
          <el-input v-model='form.titleAdd' size='mini' placeholder='请输入补结算对账标题' />
        </el-form-item>
        <el-form-item label='计划日期:'>
          <el-date-picker
            v-model="form.planTime"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini">
          </el-date-picker>
          <el-date-picker v-if="false" v-model='form.planTime[0]' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange1' type='date'
                          placeholder='开始日期'/>
          <span v-if="false" style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-if="false" v-model='form.planTime[1]' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange1' type='date'
                          placeholder='结束日期'/>
        </el-form-item>
        <el-form-item label='交车日期：'>
          <el-date-picker
            v-model="form.dealer"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini">
          </el-date-picker>
          <el-date-picker v-if="false" v-model='form.dealer[0]' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange2' type='date'
                          placeholder='开始日期'/>
          <span v-if="false" style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-if="false" v-model='form.dealer[1]' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange2' type='date'
                          placeholder='结束日期'/>
        </el-form-item>
        <el-form-item label='是否生成对账单:' label-width='130px'>
          <el-select v-model='form.isRecon' filterable size='mini'
                     placeholder='请选择是否生成对账单'>
            <el-option label='全部' value=''></el-option>
            <el-option label='是' value='1'></el-option>
            <el-option label='否' value='0'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='是否生成补结算:' label-width='130px'>
          <el-select v-model='form.isAdd' size='mini' placeholder='请选择是否生成补结算'>
            <el-option label='全部' value='' />
            <el-option label='是' :value='1' />
            <el-option label='否' :value='0' />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>生成对账单</el-button>
          <el-button size='small' type='primary' @click='addResetBtn'>刷新结算</el-button>
<!--          <el-button size='small' type='primary' @click='ledgerRevise'>修改台账月</el-button>-->
          <el-button size='small' type='primary' @click='priceRefresh'>价格刷新</el-button>
          <oil-import class='ml10'
                      :uploadUrl='"/settlement/supplierLine/importSupplierOilPriceLink"'
                      :uploadText='"油价联动导入"' :is-button='true' :button-size='"small"'
                      @triggerLoading='importLoading = !importLoading'/>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='download' class='pointer'>模板下载</span>
        <span @click='OilDownload' class='pointer'>油价联动模板下载</span>
        <span style='cursor: pointer;display: inline-block;'>
        <import-statement @getList='_supplierLinePageList(0)'
                          @changeImportLoading='changeImportLoading' :type='4'/>
        </span>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          tooltip-effect='dark'
          ref='multipleTable'
          @select='handleCurrentChange'
          @select-all='handleCurrentChangeAll'
          :reserve-selection='true'
          :row-key='(row)=>{return row.id}'
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{height:'42px',}"
          :row-style="rowStyle">
          <el-table-column type='selection' align='center' width='50px'
                           :selectable='(row,index)=>{return row.isReconciliation !==1}'
                           :reserve-selection='true'/>
          <el-table-column prop='supplierName' label='供应商' align='center' width='160px'
                           show-overflow-tooltip/>
          <el-table-column prop='consignorName' label='委托商' align='center' width='160px'
                           show-overflow-tooltip/>
          <el-table-column prop='batchNumber' label='批次号' align='center' width='150px'
                           show-overflow-tooltip/>
          <el-table-column prop='waybillNo' label='运单编号' align='center' width='150px'
                           show-overflow-tooltip/>
          <el-table-column prop='frameNumber' label='车架号' align='center' width='150px'
                           show-overflow-tooltip/>
          <el-table-column prop='brandName' label='品牌' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='modelName' label='型号' align='center' width='150'
                           show-overflow-tooltip/>
          <el-table-column prop='standingBookMonth' label='台账月' align='center' width='100'
                           show-overflow-tooltip/>
          <el-table-column prop='plannedDate' label='计划日期' align='center' width='100%'>
            <template slot-scope='scope'>{{ scope.row.plannedDate|formatTime }}</template>
          </el-table-column>
          <el-table-column prop="shippingDate" label="发运日期" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.shippingDate | formatTime }}</template>
          </el-table-column>
          <!-- <el-table-column prop="shippingDate" label="发运日期" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.shippingDate|formatTime}}</template>
          </el-table-column> -->
          <el-table-column prop='deliveryDate' label='交车日期' align='center' width='120'
                           show-overflow-tooltip>
            <template slot-scope='scope'>{{ scope.row.deliveryDate|formatTime }}</template>
          </el-table-column>
          <el-table-column width='160' label='起始地' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.startType == 0 ? scope.row.startName : scope.row.startPortName }}
            </template>
          </el-table-column>
          <el-table-column width='160' label='交车地' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{
                scope.row.deliveryType == 0 ? scope.row.deliveryName : scope.row.deliveryPortName
              }}
            </template>
          </el-table-column>
          <el-table-column prop='taxRate' label='税率(%)' align='center'/>
          <el-table-column prop='taxContractPrice' label='含税合同价' align='center'/>
          <el-table-column prop='contractPrice' label='不含税合同价' align='center'/>
          <el-table-column prop='taxPreparePrice' label='含税预结算价' align='center'/>
          <el-table-column prop='preparePrice' label='不含税预结算价' width='110' align='center'/>
          <el-table-column prop='oilPrice' label='油价联动金额' width='100' align='center'/>
          <el-table-column prop='isAdd' label='是否生成补结算' align='center' width='180' >
            <template slot-scope='scope'>{{ scope.row.isAdd |isAddFormat }}
            </template>
          </el-table-column>
          <el-table-column prop='isReconciliation' label='生成对账单' align='center' >
            <template slot-scope='scope'>{{ scope.row.isReconciliation |isReconciliationFormat }}
            </template>
          </el-table-column>
          <el-table-column prop='actNo' label='对账单编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='title' label='对账单标题' width='180px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.title ? scope.row.title : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop='actNoAdd' label='补结算对账编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='titleAdd' label='补结算对账标题' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='receiptNumber' label='交单编号' align='center' width='130'
                           show-overflow-tooltip/>
          <el-table-column prop='surrenderRemarks' label='交单备注' align='center' width='130'
                           show-overflow-tooltip/>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[50, 100, 500, 1000,3000]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <el-dialog :title=" importShow ?'导入生成对账单':'生成对账单'" :visible.sync='addFlag'
               :width='dialogWith'
               center @close='dialogClose'>
      <!-- check-table-data 传入需要展示的数据
        importShow  判断是否是导入生成对账单or 生成对账单
        selectionTable 运单费用操作删除触发  传出删除后数据据 多选表格联动 重新勾选 -->
      <accountState
        :check-table-data='JSON.parse(JSON.stringify(checkTableDataProps))'
        :importShow='importShow'
        :dialog-close-parent='dialogClose'
        :settlement='settlement'
        @selectionTable='selectChange'
        ref='accountState'>
        <template slot='label'>基础信息</template>
        <template slot='label2'>运单费用</template>
        <template slot='label3'>其他费用</template>
      </accountState>
    </el-dialog>
    <!-- 修改台账月 -->
    <el-dialog title='修改台账月' :visible.sync='ledgerVisible' width='750px' center
               @close='ledgerClose'>
      <div class='ledger'>
        <div class='leader-input'>
          <span>请输入台账月：</span>
          <el-input style='display:inline-block' size='small' type='text' v-model='ledger'/>
          <div style='display:inline-block;width:calc(100% - 300px);text-align:right'>
            <el-button size='small' class='searchBtn' @click='ledgerChange'>确 定</el-button>
            <el-button size='small' class='resetBtn' @click='ledgerClose'>取 消</el-button>
          </div>
        </div>
        <el-table
          v-loading='ledgerLoad'
          :data='ledgerData'
          style='width: 100%'
          border
          :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
        >
          <el-table-column prop='batchNumber' label='批次号' min-width='150' show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='waybillNo' label='运单号' min-width='150' show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='frameNumber' label='车架号' min-width='150' show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='brandName' label='品牌' min-width='100' show-overflow-tooltip
                           align='center'/>
          <el-table-column prop='modelName' label='型号' min-width='100' show-overflow-tooltip
                           align='center'/>

          <el-table-column width='160' label='起始地' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.startType == 0 ? scope.row.startName : scope.row.startPortName }}
            </template>
          </el-table-column>
          <el-table-column width='160' label='交车地' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{
                scope.row.deliveryType == 0 ? scope.row.deliveryName : scope.row.deliveryPortName
              }}
            </template>
          </el-table-column>
          <!--          <el-table-column prop="departurePlace" label="起始地" min-width="150" show-overflow-tooltip-->
          <!--                           align="center"/>-->
          <!--          <el-table-column prop="arrivePlace" label="交车地" min-width="150" show-overflow-tooltip-->
          <!--                           align="center"/>-->
          <el-table-column prop='standingBookMonth' label='台账月' min-width='120'
                           show-overflow-tooltip align='center'/>
          <el-table-column label='操作' width='60px' align='center'>
            <template slot-scope='scope'>
              <i class='el-icon-error' style='font-size: 20px;'
                 @click='delLedger(scope.$index)'></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {supplierLinePageList} from '@/service/getData';
import {formatTime, getSessionStore} from '@/config/mUtils';
import {

  refreshSupplier, supplierLinePriceRefresh,
  updateStandingBook,
} from '@/service/basicfile';
import accountState from './accountState.vue';
import {baseUrl} from '@/config/env';
import oilImport from './oilImport.vue';
import ImportStatement from '@/views/settle/entrust/components/import-statement';

export default {
  components: {
    oilImport,
    ImportStatement,
    accountState,
  },
  data() {
    return {
      form: {
        supplier: '', // 供应商
        consignorName: '', // 委托商
        batch: '', // 批次号
        waybill: '', // 运单编号
        frame: '', // 车架号
        brand: '', // 品牌
        month: '', // 台账月
        planTime: ['', ''], // 计划日期
        dealer: ['', ''], // 交车日期
        isRecon: '', // 是否生成账单
        isAdd: '', // 是否生成补结算
        actNoAdd: '',
        titleAdd: '',
        title:'',
        page: 1,
        rows: 50,
      },
      total: 0,
      tableLoad: false,
      TableDatas: [],
      checkList: [], // 导入生成账单 选择数据
      billTitle: '',
      checkLoad: false,
      checkTableDataProps: [], // 传入需要展示的数据
      visible: false, // 导入生成账单 显示
      importShow: false,
      stepData: [],

      addFlag: false,
      dialogWith: '950px',
      name: '',
      rules: {
        plan: {
          required: true,
          message: ' ',
          trigger: 'blur',
        },
        name: [
          {
            required: true,
            message: '请输入业务名称',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 9,
            message: '长度在 3 到 9 个字符',
            trigger: 'blur',
          },
        ],
        content: {
          required: true,
          message: '请输入评审需求',
          trigger: 'blur',
        },
        type: {
          required: true,
          message: '请选择评审类型',
          trigger: 'blur',
        },
        img: {
          required: true,
          message: '请选择合同照片',
          trigger: 'blur',
        },
      },
      settlement: '', // 生成对账单时的结算方式

      // 修改台账月
      ledgerVisible: false,
      ledgerLoad: false,
      ledger: '',
      ledgerData: [],
      importLoading: false,
    };
  },
  computed: {
    stepState() {
      return function (state) {
        switch (state) {
          case '':
            return 'wait';
          case 'success':
            return 'success';
          case 'failure':
            return 'error';
        }
      };
    },
  },
  filters: {
    isReconciliationFormat(value) {
      switch (value) {
        case 0:
          return '否';
        case 1:
          return '是';
      }
    },
    isAddFormat(value) {
      switch (value) {
        case 0:
          return '否';
        case 1:
          return '是';
        case null:
          return '否';
      }
    },
    formatTime(val) {
      if (val) {
        return formatTime(val, 'yyyy-mm-dd ');
      }
      return '';
    },
  },
  mounted() {
    // 0 公路 1 水路
   // this._supplierLinePageList(0);
  },
  methods: {
    // 导出数据
    exportData() {
      let token = getSessionStore('token');
      const exportParams = {
        supplierType: 0,
        supplierName: this.form.supplier,
        consignorName: this.form.consignorName,
        batchNumber: this.form.batch,
        waybillNo: this.form.waybill,
        frameNumber: this.form.frame,
        brandName: this.form.brand,
        standingBookMonth: this.form.month,
        planStartDate: this.form.planTime[0] || '',
        planEndDate: this.form.planTime[1] || '',
        deliveryStartDate: this.form.dealer[0] || '',
        deliveryEndDate: this.form.dealer[1] || '',
        isReconciliation: this.form.isRecon,
        isAdd: this.form.isAdd,
        title:this.form.title,
      }
      this.importLoading = true
      window.exportExcel(`${baseUrl}/platform/settlement/supplierLine/exportXls?access_token=${token}`, exportParams, '供应商公路托运费结算');
      this.importLoading = false
    },
    // 分页查询
    async _supplierLinePageList(supplierType) {
      const {
        supplier,
        consignorName,
        isRecon,
        batch,
        page,
        rows,
      } = this.form;
      this.tableLoad = true;
      const res = await supplierLinePageList({
        // 0 公路 1 水路
        supplierType,
        supplierName: supplier,
        consignorName: consignorName,
        batchNumber: batch,
        waybillNo: this.form.waybill,
        frameNumber: this.form.frame,
        brandName: this.form.brand,
        standingBookMonth: this.form.month,
        planStartDate: this.form.planTime[0] || '',
        planEndDate: this.form.planTime[1] || '',
        deliveryStartDate: this.form.dealer[0] || '',
        deliveryEndDate: this.form.dealer[1] || '',
        isReconciliation: isRecon,
        isAdd: this.form.isAdd,
        actNoAdd: this.form.actNoAdd,
        titleAdd: this.form.titleAdd,
        page,
        rows,
      });
      this.tableLoad = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.TableDatas = res.data.records;
      this.total = res.data.total;
    },
    // 生成对账单按钮
    addBtn() {
      if (this.checkTableDataProps.length <= 0) return this.$message.warning('请至少选择一条结算数据！');
      let supplierFlag = false; // 供应商
      let taxFlag = false; // 税率
      let reconciliationFlag = false; // 是否生成对账单
      if (this.checkTableDataProps.length > 0) {
        const {
          supplierId,
          taxRate,
        } = this.checkTableDataProps[0];
        this.checkTableDataProps.forEach((item) => {
          if (item.supplierId !== supplierId) {
            supplierFlag = true;
          }
          if (item.taxRate !== taxRate) {
            taxFlag = true;
          }
          if (item.isReconciliation) {
            reconciliationFlag = true;
          }
        });
      }
      if (supplierFlag) return this.$message.warning('只能选择同一家供应商数据！');
      if (taxFlag) return this.$message.warning('部分数据税率不相等！');
      if (reconciliationFlag) return this.$message.warning('部分数据已生成对账单！');

      this.$confirm('请选择结算方式', '提示', {
        confirmButtonText: '合同价',
        cancelButtonText: '预结算',
        distinguishCancelAndClose: true,
        type: 'warning',
      })
        .then(() => {
          let type = false;
          this.checkTableDataProps.forEach((item) => {
            if (!item.taxContractPrice || item.taxContractPrice == '' || !item.contractPrice || item.contractPrice == '') {
              type = true;
            }
          });
          if (type) {
            this.$message.warning('操作失败，部分数据未拥有预结算价！');
            return;
          }
          this.settlement = 1;
          // 生成对账单弹窗显示
          this.addFlag = true;
          this.$nextTick(() => {
            this.$refs.accountState.init(this.checkTableDataProps, 4);
          });
          // 判断是否是导入生成对账单
          this.importShow = false;
        })
        .catch((action) => {
          console.log(111, action);
          if (action == 'close') return;
          let type = false;
          let state = false;
          this.checkTableDataProps.forEach((item) => {
            if (item.taxContractPrice && item.taxContractPrice != '' && item.contractPrice && item.contractPrice != '') {
              type = true;
            }
          });
          if (type) {
            this.$message.warning('部分数据只能使用合同价！');
            return;
          }
          this.checkTableDataProps.forEach((item) => {
            if (!item.taxPreparePrice || item.taxPreparePrice == '' || !item.preparePrice || item.preparePrice == '') {
              state = true;
            }
          });
          if (state) {
            this.$message.warning('操作失败，部分数据未拥有预结算价！');
            return;
          }
          this.settlement = 2;
          // 生成对账单弹窗显示
          this.addFlag = true;
          this.$nextTick(() => {
            this.$refs.accountState.init(this.checkTableDataProps, 4);
          });
          // 判断是否是导入生成对账单
          this.importShow = false;
        });
    },
    // 刷新结算按钮
    async addResetBtn() {
      this.importLoading = true;
      const res = await refreshSupplier({
        type: 0,
        frameNumber: this.form.frame
      });
      this.importLoading = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      await this._supplierLinePageList(0);
    },
    // 查询
    searchBtn() {
      this.form.page = 1;
      this._supplierLinePageList(0);
    },
    // 重置
    resetBtn() {
      for (const argumentsKey in this.form) {
        this.form[argumentsKey] = '';
      }
      this.form.page = 1;
      this.form.rows = 10;
    },
    contractSizeChange(row) {
      this.form.rows = row;
      this._supplierLinePageList(0);
    },
    contractCurrentChange(page) {
      this.form.page = page;
      this._supplierLinePageList(0);
    },
    // 计划开始-结束日期验证
    dateChange1(val) {
      if (this.form.planTime[1] && this.form.planTime[0] && (this.form.planTime[1] <= this.form.planTime[0])) {
        if (val == this.form.planTime[1]) this.form.planTime[1] = '';
        if (val == this.form.planTime[0]) this.form.planTime[0] = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    // 交车开始-结束日期验证
    dateChange2(val) {
      if (this.form.dealer[1] && this.form.dealer[0] && (this.form.dealer[1] <= this.form.dealer[0])) {
        if (val == this.form.dealer[1]) this.form.dealer[1] = '';
        if (val == this.form.dealer[0]) this.form.dealer[0] = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    // 价格刷新
    async priceRefresh() {
      this.importLoading = true;
      let supplierType = 0;
      const {
        supplier,
        consignorName,
        batch,
      } = this.form;
      if (supplier === null || supplier == undefined || supplier === '') {
        this.importLoading = false;
        return this.$message.warning("操作失败，请填写供应商！");
      }
      const {
        status,
        message,
      } = await supplierLinePriceRefresh({
        // 0 公路 1 水路
        supplierType,
        supplierName: supplier,
        consignorName: consignorName,
        batchNumber: batch,
        waybillNo: this.form.waybill,
        frameNumber: this.form.frame,
        brandName: this.form.brand,
        standingBookMonth: this.form.month,
        planStartDate: this.form.planTime[0] || '',
        planEndDate: this.form.planTime[1] || '',
        deliveryStartDate: this.form.dealer[0] || '',
        deliveryEndDate: this.form.dealer[1] || '',
        isAdd: this.form.isAdd,
        actNoAdd: this.form.actNoAdd,
        titleAdd: this.form.titleAdd,
      });
      this.importLoading = false;
      if (status !== 0) return this.$message.warning(message);
      this.$message.success(message);
    },

    // 修改台账月 -- 打开弹窗
    // ledgerRevise() {
    //   if (!this.checkTableDataProps.length || this.checkTableDataProps.length == 0) return this.$message.error('请选择至少一条数据！');
    //   if (this.checkTableDataProps.length > 100) return this.$message.error('最多选择100条数据！');
    //   this.ledgerData = this.checkTableDataProps;
    //   this.ledgerVisible = true;
    // },
    // 修改台账月 -- 删除
    delLedger(index) {
      this.ledgerData.splice(index, 1);
    },
    // 修改台账月 -- 确认
    async ledgerChange() {
      const params = {
        standingBookMonth: this.ledger,
        freightList: [],
      };
      this.ledgerData.forEach((res) => {
        params.freightList.push({id: res.id});
      });
      await updateStandingBook(params)
        .then((res) => {
          if (res.status === 0) {
            this.$message.success(res.message);
            this.ledgerVisible = false;
            this.searchBtn();
          } else {
            this.$message.error(res.message);
          }
        });
    },
    // 修改台账月 -- 取消(关闭弹窗)
    ledgerClose() {
      this.ledger = '';
      this.ledgerData = [];
      this.ledgerVisible = false;
    },

    getSummaries(param) {
      const {
        columns,
        data,
      } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
        } else if (index >= 11) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => prev + curr, 0);
          }
        }
      });
      return sums;
    },
    // 导入
    importClick(index, row) {
      if (this.checkList.length < 3) return this.$message.warning('至少选择三个条件');
      this.visible = false;
      this.importShow = true;
      this.addFlag = true;
    },
    tableRowClassName({row}) {
      if (row.remark === '价格异常') return 'ui-warning-row';
      return '';
    },
    // 多选事件触发
    handleCurrentChange(val) {
      this.checkTableDataProps = val;
      let Waybill = '';
      if (val.length > 0) {
        const array = val.filter((item, index) => {
          // 取第一行
          if (index === 0) Waybill = item.supplierName;
          // 赛选不等于第一行的数据
          return Waybill !== item.supplierName;
        });
        // 筛选  供应商相同数据
        this.checkTableDataProps = val.filter(item => Waybill === item.supplierName);
        // 与第一行不相等的数据
        array.forEach((value) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          this.$message.warning('只能选择相同的供应商');
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => value.id === item.id), false);
        });
      }
    },
    rowStyle({ row }) {
      return this.checkTableDataProps.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    handleCurrentChangeAll(val) {
      this.checkTableDataProps = val;

      // this.$refs.accountState.calculation()
    },
    // 子组件 表格勾选触发
    selectChange(val) {
      // 先清空选择
      this.$refs.multipleTable.clearSelection();
      // 将子组件表格数据赋值。
      this.checkTableDataProps = val;
      this.$nextTick(() => {
        val.forEach((row) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选  重新勾选
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => row.id === item.id));
        });
      });
    },
    dialogClose() {
      this.$refs.accountState.activeName = 'information';
      this.name = 'information';
      this.addFlag = false;
    },
    selectable(row, index) {
      return row.isReconciliation === 1;
    },
    download() {
      window.location.href = '/file/供应商导入模板（含结算方式）.xlsx';
    },
    OilDownload() {
      window.location.href = '/file/油价联动模板.xlsx';
    },
    changeImportLoading(flag) {
      this.importLoading = flag;
    },
    searchCopyFormat(value, flag) {
      let splitArr = value.clipboardData.getData('Text')
        .replace(/\s/g, ',')
        .split(',');
      splitArr = splitArr.filter(item => item);
      splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
      switch (flag) {
        case 'frame':
          this.form.frame = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
          break;
      }
    },
  },
};
</script>


<style lang='scss' scoped>
.supplier-highWay {
  width: 100%;
  /*padding:20px 15px 0 25px;*/
  height: 100%;

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      margin-right: 10px;
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
    color: #606266;
    content: "全选";
    font-size: 12px;
    margin-left: 2px;

  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    overflow: hidden;

    .navContainer {
      display: inline-block;

      p {
        display: inline-block;
        width: 80px;
        text-align: right;
      }
    }

    .flex1 {
      flex: 1;
    }

    .el-input {
      width: 150px;
    }

    .el-select {
      width: 150px;
    }

    .el-form-item {
      margin-bottom: 12px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
        line-height: 30px;
      }

      .el-form-item__content {
        line-height: 30px;
      }
    }
    .ml10 {
      ::v-deep  .upload-demo{
        margin: -32px 400px;
      }
    }
  }

  .ledger {
    padding: 20px;

    .leader-input {
      display: inline-block;
      width: 100%;
      margin-bottom: 15px;

      span {
        display: inline-block;
        width: 100px;
      }

      ::v-deep {
        .el-input.el-input--small {
          display: inline-block;
          width: 200px;
        }
      }
    }

    ::v-deep {
      .el-table td {
        padding: 5px;
      }

      .el-table td, .el-table th {
        font-size: 13px;
        padding: 5px;
      }
    }
  }

  ::v-deep.content {
    .el-table th > .cell {
      font-weight: 700 !important;
    }

    .el-table .cell, .el-table td {
      padding: 0;
    }
  }

  ::v-deep .importBill {
    width: 100%;
    padding: 10px 0 20px 20px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .el-table td, .el-table th {
      padding: 0;
    }

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        /*padding:20px 23px 0 23px;*/
        padding-right: 20px;
        margin-top: 20px;
        font-size: 14px;

        .el-table .ui-warning-row {
          background-color: #fef0f0 !important;
        }

        .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
          background-color: #fef0f0 !important;
        }

        .el-table .ui-warning-row .cell {
          color: red;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .iconError {
          font-size: 15px;

          i:hover {
            color: #00e1ff;
          }
        }


      }
    }

    .operation {
      display: flex;
      flex-direction: column;
      margin-top: 20px;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      .cell {
        font-size: 10px;
        padding: 0;
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding-right: 20px;

        .el-button--mini {
          padding: 4px 4px;
        }
      }
    }
  }

  ::v-deep .add {


    font-weight: 700;
    width: 100%;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Input {
        display: flex;
        height: 30px;
        line-height: 30px
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .el-table td, .el-table th {
          padding: 0;
        }

        .iconError {
          font-size: 20px;

          i:hover {
            color: #00e1ff;
          }
        }

        .yang {
          .el-form-item {

            margin-bottom: 15px;

            .el-form-item__label {
              /*width: 150px !important;*/
              /*color: #060606;*/
            }

            .el-input {
              width: 430px;
            }

            .el-textarea {
              width: 250px;

            }
          }

        }

      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 13px;
      margin-top: 20px;

      button {
        margin: 0 15px;
      }
    }
  }

  ::v-deep {
    .el-table td {
      font-size: 13px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

  }

}

</style>
